import development from './development'
import production from './production'
import qa from './qa'
import qualQa from './qual-qa'
import test from './test'

export const environments = {
  development,
  production,
  qa,
  qualQa,
  test,
}

export default
  environments[process.env.DEPLOY_ENV || process.env.NODE_ENV] || environments.development
